import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/material/styles";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = styled((props) => ({
  root: {
    "& .MuiPaper-root": {
      background: "green",
      color: "white",
    },
  },
  error: {
    "& .MuiPaper-root": {
      background: "red",
      color: "white",
    },
  },
  warning: {
    "& .MuiPaper-root": {
      background: "orange",
      color: "white",
    },
  },
  info: {
    "& .MuiPaper-root": {
      background: "yellow",
      color: "white",
    },
  },
  default: {
    "& .MuiPaper-root": {
      background: "grey",
      color: "white",
    },
  },
}));

// @name SnackBar
// @desc to get snackbar with a message depending on severity of status.
// @params {object}props - props has severity and message
// @author Sahithi
const SnackBar = (props) => {
  const [open, setOpen] = React.useState(props.open);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const classes = useStyles(props);
  return (
    <div
      className={
        props.severity === "success"
          ? classes.root
          : props.severity === "error"
            ? classes.error
            : props.severity === "warning"
              ? classes.warning
              : props.severity === "info"
                ? classes.info
                : classes.default
      }
    >
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      // sx={{ "& .MuiSnackbar-root.MuiPaper-root": "success.main" }}
      >
        <Alert
          onClose={handleClose}
          severity={props.severity}
          sx={{ width: "100%" }}
        >
          {props.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SnackBar;
